import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.5;
    background-color: #f5f8fb;
    color: #162845;
  }

  button {
    font-family: inherit;
    border: none;
    cursor: pointer;
    background: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol {
    list-style: none;
  }

  :root {
    --primary-color: #FF8F00;
    --primary-hover: #E68000;
    --primary-dark: #D97700;
    --primary-light: rgba(255, 143, 0, 0.1);
    --secondary-color: #162845;
    --secondary-hover: #0F1D36;
    --secondary-light: rgba(22, 40, 69, 0.1);
    --success-color: #00C875;
    --success-dark: #00A661;
    --success-light: rgba(0, 200, 117, 0.1);
    --warning-color: #FFCB00;
    --warning-light: rgba(255, 203, 0, 0.1);
    --danger-color: #ff4d4f;
    --danger-light: #fff1f0;
    --partner-color: #10b981;
    --partner-dark: #059669;
    --partner-light: rgba(16, 185, 129, 0.1);
    --client-color: #ef4444;
    --client-dark: #dc2626;
    --client-light: rgba(239, 68, 68, 0.1);
    --gray-50: #fafafa;
    --gray-100: #f5f5f7;
    --gray-200: #eaeaea;
    --gray-300: #e1e1e1;
    --gray-400: #cacaca;
    --gray-500: #999999;
    --gray-600: #666666;
    --gray-700: #333333;
    --gray-800: #222222;
    --gray-900: #111111;
    --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.05);
    --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.05);
    --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.05);
    --shadow-xl: 0 16px 32px rgba(0, 0, 0, 0.05);
    --rounded-xs: 4px;
    --rounded-sm: 6px;
    --rounded-md: 8px;
    --rounded-lg: 12px;
    --rounded-xl: 16px;
    --rounded-full: 9999px;
    --transition-fast: all 0.2s ease;
    --transition: all 0.3s ease;
    --transition-slow: all 0.4s ease;
    --z-tooltip: 10;
    --z-overlay: 20;
    --z-modal: 30;
    --text-xs: 0.75rem;
    --text-sm: 0.875rem;
    --text-md: 1rem;
    --text-lg: 1.125rem;
    --text-xl: 1.25rem;
    --text-2xl: 1.5rem;
    --text-3xl: 1.875rem;
    --text-4xl: 2.25rem;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: var(--gray-100);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--gray-400);
    border-radius: var(--rounded-full);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--gray-500);
  }
`;
